'use strict';

const cookies = require('js-cookie');

const moment = require('../../util/date');

const oneMinute = 60;
const oneHour = 60 * 60;
const oneDay = 60 * 60 * 24;

function controller($attrs, $http, $setInterval, $sce) {
    const vm = this;

    vm.loading = true;

    vm.video_details = false;

    vm.countdown = '';
    vm.date = '';
    vm.embed_code = '';
    vm.error_message = '';
    vm.is_logged = cookies.get('_bo_logged_in');
    vm.scheduled_at = false;
    vm.now = moment.moment();

    vm.displayVideoPopup = false;
    vm.displayVideoLoaderButton = false;
    vm.displayVideoPreloader = true;

    vm.hasDigitalPass = false;
    vm.displayDigitalPassPopup = false;

    vm.can_request_video = false;

    vm.accessToVideo = false;
    vm.expirationTime = false;
    vm.timeLeft = false;

    /*global jwplayer*/
    vm.player = jwplayer($attrs.videoId);

    vm.init = () => {
        validateAccessRequest();
    }

    vm.getVideo = () => {
        vm.displayVideoPopup = false;
        vm.displayVideoLoaderButton  = false;

        vm.player.play();

        $http.get($attrs.videoTrackingLink, {withCredentials: true});
    }

    vm.showPopup = () => {
        vm.displayVideoPopup = true;
    }

    vm.closePopup = () => {
        vm.displayVideoPopup = false;
    }

    vm.showDigitalPassPopup = () => {
        vm.displayDigitalPassPopup = true;
    }

    vm.closeDigitalPassPopup = () => {
        vm.displayDigitalPassPopup = false;
    }

    function validateAccessRequest() {
        $http.get($attrs.validateAccessLink, {withCredentials: true}).then(boResponse => {
            if (boResponse.data['is_logged']) {
                vm.is_logged = boResponse.data.is_logged;
            }

            if (boResponse) {
                vm.video_details = boResponse.data['video_details'];
                vm.date = boResponse.data['date'];
                if (boResponse.data.video_details.sources) {
                    vm.video_details.sources = JSON.parse(boResponse.data.video_details.sources);
                }
                if (boResponse.data.video_details.tracks) {
                    vm.video_details.tracks = JSON.parse(boResponse.data.video_details.tracks);
                }
                vm.can_request_video = boResponse.data['can_request_video'];
                vm.is_livestream = boResponse.data['isLiveStream'];
                vm.accessToVideo = boResponse.data['accessToVideo'];
                vm.hasDigitalPass = boResponse.data['hasDigitalPass'];

                vm.expirationTime = boResponse.data['expiration_time'];
                if (vm.expirationTime) {
                    vm.expirationTime = moment.moment(vm.expirationTime);
                    const diff = parseInt(vm.expirationTime.diff(vm.now) / 1000, 10);

                    if (diff > 0) {
                        const expirationInterval = $setInterval(() => {
                            let countdown = initCountDown(expirationInterval, vm.expirationTime, true);
                            vm.timeLeft = $sce.trustAsHtml(countdown ? 'You have <strong>' + countdown + 'left</strong> to watch this video' : 'Expiring shortly');
                        }, 500);
                    }
                }

                vm.scheduled_at = moment.moment(boResponse.data['start_date']);
                if (vm.scheduled_at > vm.now) {
                    const countdownInterval = $setInterval(() => {
                        if (vm.scheduled_at > vm.now) {
                            let countdown = initCountDown(countdownInterval, vm.scheduled_at);
                            vm.countdown = $sce.trustAsHtml((vm.is_livestream ? 'begins in ' : 'available in ') + countdown);
                        } else {
                            vm.countdown = '';
                        }
                    }, 500);
                }
            }

            if (vm.video_details.sources) {
                initVideo();
            }

            if (vm.video_details.sources && !vm.can_request_video) {
                vm.displayVideoLoaderButton = true;
            }

            vm.loading = false;
            vm.displayVideoPreloader = false;
            // eslint-disable-next-line no-unused-vars
        }).catch(errResponse => {
        }).finally(() => {
            vm.loading = false;
            vm.displayVideoPreloader = false;
        });
    }

    function initVideo() {
        vm.player.setup({
            "playlist": [{
                "sources": vm.video_details.sources,
                "tracks": vm.video_details.tracks,
                "image": vm.video_details.image
            }],
            "cast": {}
        });
    }

    function initCountDown(countdownInterval, scheduled_at, skipSeconds) {
        let countdown = '';
        vm.now = moment.moment();

        const diff = parseInt(scheduled_at.diff(vm.now) / 1000, 10);

        if (diff < 0) {
            $setInterval.cancel(countdownInterval);

            return '';
        }

        const daysLeft = Math.floor(diff / oneDay);
        const hoursLeft = Math.floor((diff - (oneDay * daysLeft)) / oneHour);
        const minutesLeft = Math.floor((diff - (oneDay * daysLeft + hoursLeft * oneHour)) / oneMinute);
        const secondsLeft = (diff - (oneDay * daysLeft + hoursLeft * oneHour + minutesLeft * oneMinute));

        // Formats the amount of time left
        if (daysLeft) {
            countdown += `<b>${daysLeft}</b> day${daysLeft > 1 ? 's' : ''} `;
        }

        if (hoursLeft) {
            countdown += `<b>${hoursLeft}</b> hour${hoursLeft > 1 ? 's' : ''} `;
        }

        if (minutesLeft) {
            countdown += `<b>${minutesLeft}</b> minute${minutesLeft > 1 ? 's' : ''} `;
        }

        if (!skipSeconds) {
            if (secondsLeft) {
                countdown += `<b>${secondsLeft}</b> second${secondsLeft > 1 ? 's' : ''} `;
            }
        }

        return countdown;
    }

    return vm;
}

module.exports = [
    '$attrs', '$http', '$interval', '$sce', controller,
];
